export default __webpack_public_path__ + "static/media/KP-image.b5a218f5.png";